export const GENERAL_SETTING_REQUEST  = 'GENERAL_SETTING_REQUEST';
export const SET_GENERAL_SETTING = 'SET_GENERAL_SETTING';
export const GENERAL_SETTING_REQUEST_FAILURE = 'GENERAL_SETTING_REQUEST_FAILURE';
export const SET_RELOAD_SETTINGS_PAYLOAD = 'SET_RELOAD_SETTINGS_PAYLOAD';